import { ReactComponent as phyllo_logo } from "./phyllo_logo.svg";
import { ReactComponent as tiktokIcon } from "./tiktok_icon.svg";
import { ReactComponent as instagramIcon } from "./instagram_icon.svg";
import { ReactComponent as youtubeIcon } from "./youtube_icon.svg";
import { ReactComponent as twitchIcon } from "./twitch_icon.svg";
import { ReactComponent as twitterIcon } from "./twitter_icon.svg";
import { ReactComponent as facebookIcon } from "./facebook_icon.svg";
import { ReactComponent as add_other_platforms } from "./add_other_platforms.svg";
import { ReactComponent as back_arrow } from "./back_arrow.svg";
import { ReactComponent as permissions_loading } from "./permissions_loading.svg";
import { ReactComponent as content_loading } from "./content_loading.svg";
import { ReactComponent as attention_icon } from "./attention_icon.svg";
import { ReactComponent as link_redirect_arrow } from "./link_redirect_arrow.svg";
import { ReactComponent as success_icon } from "./success_icon.svg";
import { ReactComponent as completed_icon } from "./completed_icon.svg";
import { ReactComponent as placeholder_profile } from "./placeholder_profile.svg";
import { ReactComponent as heart_break_icon } from "./heart_break_icon.svg";
import { ReactComponent as thinking_icon } from "./thinking_icon.svg";
import { ReactComponent as downwardArrow } from "./downwardArrow.svg";
import { ReactComponent as upwardArrow } from "./upwardArrow.svg";
import { ReactComponent as content_loading_small } from "./content_loading_small.svg";
import { ReactComponent as permissions_loading_small } from "./permissions_loading_small.svg";
import { ReactComponent as connection_step1 } from "./connection_step1.svg";
import { ReactComponent as connection_step3 } from "./connection_step3.svg";
import { ReactComponent as content_loading_mobile } from "./content_loading_mobile.svg";
import { ReactComponent as permissions_loading_mobile } from "./permissions_loading_mobile.svg";

export default {
  phyllo_logo,
  tiktokIcon,
  instagramIcon,
  youtubeIcon,
  twitchIcon,
  twitterIcon,
  facebookIcon,
  add_other_platforms,
  back_arrow,
  permissions_loading,
  content_loading,
  attention_icon,
  link_redirect_arrow,
  success_icon,
  completed_icon,
  placeholder_profile,
  heart_break_icon,
  thinking_icon,
  downwardArrow,
  upwardArrow,
  content_loading_small,
  permissions_loading_small,
  connection_step1,
  connection_step3,
  content_loading_mobile,
  permissions_loading_mobile,
};
